import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getPoints = createAsyncThunk('points/getPoints', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getPoints();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const getPointsPrice = createAsyncThunk('points/getPointsPrice', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getPointsConditions();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
